<template>
  <a>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C7.35804 0 5.20825 2.14979 5.20825 4.79176C5.20825 7.43372 7.35803 9.58333 10 9.58333C12.642 9.58333 14.7918 7.43372 14.7918 4.79176C14.7918 2.14979 12.642 0 10 0ZM6.2755 4.79176C6.2755 2.73768 7.94613 1.06724 10 1.06724C12.0539 1.06724 13.7245 2.73768 13.7245 4.79176C13.7245 6.84566 12.0539 8.51609 10 8.51609C7.94614 8.51609 6.2755 6.84566 6.2755 4.79176Z"
        fill="#FF7010"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.96381 11.6665C3.59468 11.6665 1.66663 13.6453 1.66663 16.0768V19.4881C1.66663 19.7705 1.89005 19.9998 2.1652 19.9998H17.8347C18.1099 19.9998 18.3333 19.7705 18.3333 19.4881V16.0768C18.3333 13.6453 16.4052 11.6665 14.0361 11.6665H5.96381ZM2.66378 16.0768C2.66378 14.2092 4.14412 12.6899 5.96381 12.6899H14.0361C15.8558 12.6899 17.3361 14.2092 17.3361 16.0768V18.9764H2.66378V16.0768Z"
        fill="#FF7010"
      />
    </svg>

    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "ButtonRegister",
};
</script>

<style scoped lang="scss">
a {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: fit-content;
}
svg {
  margin-right: 8px;
}
</style>
